import { Routes } from '@angular/router';
import { AuthGuardWithForcedLogin } from '@ortho-next/auth-core';
import { AppVersionGuard } from './app-version.guard';
import { ArchiveComponent } from './archive';
import { ErrorComponent, FallbackComponent, PAGE } from './core';
import { DashboardComponent } from './dashboard';
import { ListComponent, NestedPatientTableComponent, PlanTableComponent, ReceivedTableComponent } from './list';
import { PatientCreationComponent } from './patient';
import { PlanComponent } from './plan';
import { ProfileFormComponent } from './profile';
import { ContainerTemplateComponent } from './template';


export const routes: Routes = [
	{ path: PAGE.ERROR, component: ErrorComponent },
	{
		path: '', component: ContainerTemplateComponent, children: [
			{ path: '', redirectTo: PAGE.DASHBOARD, pathMatch: 'full' },
			{ path: PAGE.DASHBOARD, component: DashboardComponent, canActivate: [AuthGuardWithForcedLogin] },
			{
				path: PAGE.LIST, component: ListComponent, children: [
					{ path: '', redirectTo: 'plans', pathMatch: 'full' },
					{ path: 'plans', component: NestedPatientTableComponent, canActivate: [AuthGuardWithForcedLogin] },
					{ path: 'received', component: ReceivedTableComponent, canActivate: [AuthGuardWithForcedLogin] },
					{ path: 'onlyplans', component: PlanTableComponent, canActivate: [AuthGuardWithForcedLogin] }
				], canActivate: [AuthGuardWithForcedLogin]
			},
			{ path: PAGE.LIST_ARCHIVE, component: ArchiveComponent, canActivate: [AuthGuardWithForcedLogin] },
			{ path: PAGE.PATIENT_NEW, component: PatientCreationComponent, canActivate: [AuthGuardWithForcedLogin] },
			{ path: PAGE.PATIENT_EDIT, component: PatientCreationComponent, canActivate: [AuthGuardWithForcedLogin] },
			{ path: PAGE.PLAN_NEW, component: PlanComponent, canActivate: [AuthGuardWithForcedLogin] },
			{ path: PAGE.PLAN_EDIT, component: PlanComponent, canActivate: [AuthGuardWithForcedLogin] },
			{ path: PAGE.PROFILE_EDIT, component: ProfileFormComponent, canActivate: [AuthGuardWithForcedLogin] }
		], canActivate: [AuthGuardWithForcedLogin, AppVersionGuard]
	},
	{ path: '**', component: FallbackComponent, canActivate: [AuthGuardWithForcedLogin] },
];